import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSnackBar, MatTableDataSource } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { PermissoesService } from 'app/service/usuario/permissoes.service';

import { DadosArquivisticosService } from '../dados-arquivisticos/dados-arquivisticos.service';
import { EditAspectDialogComponent } from '../dialog/edit-aspect-dialog/edit-aspect-dialog.component';

@Component({
  selector: 'app-edit-aspecto',
  templateUrl: './edit-aspecto.component.html',
  styleUrls: ['./edit-aspecto.component.scss'],
})
export class EditAspectoComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private arrayString: string;
  authorityUser = [];
  superUserGeneral = false;
  superUser = false;
  loading = true;
  aspects: any[];
  nodeId: number;
  clienteId: number;
  tipoName: string = '';
  displayedColumns = ['title', 'name', 'description', 'ativo', 'action'];
  dataSource = new MatTableDataSource<any[]>([]);

  constructor(
    private dadosService: DadosArquivisticosService,
    private activeRoute: ActivatedRoute,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private permissoesService: PermissoesService,
    private route: ActivatedRoute,
  ) {
    this.route.params.subscribe(params => {
      this.clienteId = params['clienteId']
      if(this.clienteId) {
        this.getPermissionCliente(this.clienteId);
      }
      this.getGlobalPermissionUser();
    }, error => {
      console.error(error)
      this.loading = false;
      this.openSnackBar('Ocorreu um erro ao buscar url, tente novamente em alguns instantes', true)
    });
  }

  ngOnInit() {
    this.getAllAspects();
  }

  getPermissionCliente(idCliente: number) {
    this.loading = true;
    this.permissoesService.getPermissionEmpresa(idCliente).subscribe(data => {
      const arrayAuthorityCliente: any[] = [];
      data.forEach(el => {
        arrayAuthorityCliente.push(el.authority);
      });
      this.permissoesService.setItemAuthority('authority-Empresa', arrayAuthorityCliente);
      this.getAuthority();
      this.loading = false;
    }, err => {
      this.loading = false;
      console.error(err);
      this.openSnackBar('Ocorreu um erro, tente novamente mais tarde', true);
    });
  }

  getAuthority() {
    this.arrayString = this.permissoesService.getItemAuthority('authority-Empresa');
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getAuthorityUser() {
    if (this.authorityUser.includes("SUPER_USER")) {
      this.superUserGeneral = true;
    }
  }

  getGlobalPermissionUser() {
    this.permissoesService
      .getPermissionsInUserLogged()
      .subscribe((data: any[]) => {
        this.authorityUser = data.map((el) => el.name);
        this.getAuthorityUser();
        this.loading = false;
      }, err => {
        this.loading = false;
      });
  }

  getAllAspects() {
    this.loading = true;
    this.activeRoute.params.subscribe(
      (params) => {
        this.nodeId = params['tipoId'];
        this.clienteId = params['clienteId'];

        this.dadosService.listarNodeDicionario(this.nodeId).subscribe(
          (data) => {
            this.tipoName = data.title;
            this.dataSource.data = data.aspectos;
            this.loading = false;
          },
          (err) => {
            this.handleError(err, 'ao carregar aspectos');
          }
        );
      },
      (err) => {
        this.handleError(err, 'ao buscar o tipo documental');
      }
    );
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  openAspectEditDialog(asp) {
    let largura;
    if (innerWidth < 400) {
      largura = innerWidth - 50 + 'px';
    } else {
      largura = innerWidth / 2 + 'px';
    }

    const dialogRef = this.dialog.open(EditAspectDialogComponent, {
      data: { clientId: this.clienteId, asp },
      width: largura,
    });
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result) {
          this.getAllAspects();
        }
      },
      (err) => {
        this.handleError(
          err,
          'Ocorreu um erro, tente novamente em alguns instantes'
        );
      }
    );
  }

  handleError(error, msg) {
    this.loading = false;
    console.error(error);
    this.openSnackBar(
      `Ocorreu um erro ${msg}, tente novamente em alguns instantes`,
      true
    );
  }

  openSnackBar(message: string, isErr: boolean) {
    this._snackBar.open(message, '', {
      horizontalPosition: 'right',
      verticalPosition: 'top',
      duration: 3000,
      panelClass: isErr ? ['error-snackbar'] : ['success-snackbar'],
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/edit-aspectos/edit-aspecto.component.ts